import View from 'mixins/view';
import { siteModel } from 'models/SiteModel';
import CommentModel from 'models/CommentModel';
import AvatarView from '@ui/comments/avatar-view';
import CommentsService from '@ui/comments/CommentService';

export const elements = {
    input: '.text-editor',
    form: 'form.c-comments__content',
    buttonsContainer: '.comment-textfield__btns',
    mainCommentInput: '.c-comments__main--editor .text-editor'
};

export default class extends View {
    constructor(model) {
        super(model);

        this.value = '';
        this.setRootEl($(`<div class="c-comments__main c-comments__main--editor c-comments__main--add-new-comment"></div>`));

        const handleAddedCurrentReply = (event) => {
          if (this.model.get('id') === parseInt(event.detail.parentCommentId)) {
            this.value = '';
            this.render();
          }
        };
        document.addEventListener('AddReplyCommentSuccess',
          handleAddedCurrentReply);
    }
    setReplyData() {
        const dataParent = CommentsService
          .getVisibleCommentsCollection()
          .getBaseComment(this.model)
          .get('id');

        this.data = `data-parent='${ dataParent }'`;
    }
    /*
     * Get comment value
     */
    getValue() {
        return this.value;
    }
    /*
     * Dynamically set comment value function and
     * update trigger function used for caret + submit
     */
    setValue(value) {
        this.value = value;
    }
    onValueChanged() {
        const $submit = this.rootEl.find(`${elements.buttonsContainer} button`);
        if (CommentModel.isMessageCorrect(this.value)) {
            $submit.removeClass('hide');
        } else {
            $submit.addClass('hide');
        }
        // setTimeout(this.setCaretPosition.bind(this), 0);
    }
    setCaretPosition() {
        const input = this.rootEl
          .find(elements.input);

        input.focus();

          // Move caret to a specific point in a DOM element
          const setCaretPosition = (el, pos) => {

              // Loop through all child nodes
              for(let node of el.childNodes){
                  if(node.nodeType == 3){ // we have a text node
                      if(node.length >= pos){
                          // finally add our range
                          const range = document.createRange();
                          const sel = window.getSelection();
                          range.setStart(node,pos);
                          range.collapse(true);
                          sel.removeAllRanges();
                          sel.addRange(range);
                          return -1; // we are done
                      }else{
                          pos -= node.length;
                      }
                  }else{
                      pos = setCaretPosition(node,pos);
                      if(pos == -1){
                          return -1; // no need to finish the for loop
                      }
                  }
              }
              return pos; // needed because of recursion stuff
          }

          setCaretPosition(input['0'], (this.value.length));
    }
    reply(model) {
        this.setReplyData();
        const userMention = `@${model.get('User').get('username')} `;
        this.value = `${userMention}`;
        this.rootEl.addClass("c-comments__main--add-reply");
        this.render();
        // setTimeout allow to force comand executing order
        setTimeout(this.setCaretPosition.bind(this), 0);
    }
    render() {
        const User = siteModel.get('User');
        const avatarView = new AvatarView(User);
        this.rootEl.empty();
        this.addChild(avatarView);

        avatarView.render();
        this.rootEl.append([
            avatarView.getRootEl(),
            $(`
                <form class="c-comments__content" action="#" ${ (this.data) ? this.data : '' }">
                    <div class="comment-textfield">
                        <div contenteditable class="text-editor text-editor--small" placeholder="${ $(elements.mainCommentInput).attr('placeholder') }"></div>
                        <div class="comment-textfield__btns">
                            <button type="button" class="c-comments__btn c-comments__btn--send hide">Dodaj</button>
                        </div>
                        <div class="comment-custom-loader"></div>
                    </div>
                    <div class="comment-error-wrapper" data-root="${this.model.get('id')}" data-id="false"></div>
                </form>
            `),
        ]);

        const classPointer = this;
        const $contenteditable = this.rootEl.find(elements.input);
        $contenteditable.on('keyup', function() {
          classPointer.value = $(this).text();
        });

        $contenteditable
          .text(this.value)
          .on('paste', (event) => {
            event.preventDefault();
            const pasted = event.originalEvent
              .clipboardData
              .getData('text/plain');

              if (document.queryCommandSupported('insertText')) {
                document.execCommand('insertText', false, pasted);
              } else {
                document.execCommand('paste', false, pasted);
              }

              const value = $contenteditable.html().replace(/<(br)[^<]*?>/g, '\n').replace(/<div>/g, '').replace(/<\/div>/g, '\n').trim();
              this.setValue(value);

              this.render();
              this.onValueChanged();
          });
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/add-comment-view.js